import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';
import { Component, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { noop } from 'angular';

export interface CrossesProductCellRendererParams extends ICellRendererParams {
  showCross: boolean;
  product: string;
  content: string;
  productUrl: string;
  status: string;
  isAptitudeProduct: boolean;
}

@Component({
    selector: 'app-cross-references-product-renderer',
    templateUrl: './cross-references-product-renderer.component.html',
    styleUrls: ['./cross-references-product-renderer.component.scss'],
    standalone: false
})
export class CrossReferencesProductRendererComponent
  implements ICellRendererAngularComp, OnDestroy
{
  crossParams!: CrossesProductCellRendererParams;
  showDiscontinueBadge = false;
  _routerLink = false;

  constructor(public ngbActiveModal: NgbActiveModal) {}

  agInit(params: CrossesProductCellRendererParams): void {
    this.crossParams = params;
    this.showDiscontinueBadge =
      params.status && params.status === 'Discontinued' ? true : false;

    // this is hacky, but once we update the angularJs pages this won't be needed at all
    this._routerLink = !params.productUrl.includes('/aptitude/static');
  }

  refresh(): boolean {
    return true;
  }

  ngOnDestroy(): void {
    noop();
  }
}
